import { createServerFn } from "@tanstack/react-start"
import { z } from "zod"

const evidenceSchema = z.discriminatedUnion("kind", [
  z.object({ kind: z.literal("detection"), id: z.string().uuid() }),
  z.object({ kind: z.literal("score"), key: z.string().min(1).max(200) }),
  z.object({
    kind: z.literal("citation"),
    index: z.number().int().nonnegative(),
  }),
  z.object({ kind: z.literal("assessment") }),
])
export type FileEvidenceTarget = z.infer<typeof evidenceSchema>

const fileEvidenceInputSchema = z
  .object({
    companyRunId: z.string().uuid(),
    target: evidenceSchema,
    hasModelPayloads: z.boolean().default(false),
  })
  .strict()
export type FileEvidenceInput = z.infer<typeof fileEvidenceInputSchema>

export const loadFileEvidence = createServerFn({ method: "GET" })
  .inputValidator(fileEvidenceInputSchema)
  .handler(async ({ data }) => {
    const [{ assertAdminContext }, { readFileEvidence }] = await Promise.all([
      import("@/lib/supabase/auth"),
      import("@/admin/monitoring/file-evidence"),
    ])
    await assertAdminContext()
    return readFileEvidence(data)
  })
